import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { MetaFunction } from "react-router";
import { Meta, Links, Outlet, ScrollRestoration, Scripts, LiveReload } from "react-router";
import { VemetricScript } from "@vemetric/react";
import Footer from "~/components/layout/footer";
import Header from "~/components/layout/header";
import TransactionNotification from "~/components/transaction-notification";
import RadixProvider from "~/rdt/radixProvider";

export function links() {
  return [
    { rel: "shortcut icon", type: "image/png", href: "/assets/images/logo/reddicks-icon.png" },
    { rel: "mask-icon", sizes: "any", href: "/assets/images/logo/reddicks-icon.png", color: "#e53935" },
  ];
}

export const meta: MetaFunction = () => {
  return [{ title: "RSwap" }];
};

export default function App() {
  return (
    <html lang="en" className="dark">
      <head>
        <meta charSet="utf-8" />
        <meta name="copyright" content="RSwap is powered by DefiPlaza and Astrolescent" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#f7f5f0" media="(prefers-color-scheme: light)" />
        <meta name="theme-color" content="#0d1117" media="(prefers-color-scheme: dark)" />
        <Meta />
        <Links />
      </head>
      <body className="bg-background-500 dark:bg-background-900 oval-gradient selection:bg-primary-500 selection:text-primary-100 min-h-screen pb-4 text-black dark:text-white">
        {/* <div className="bg-[url('/assets/img/radix-incentives/bg.png')] bg-right bg-no-repeat bg-cover relative min-h-10 flex justify-between items-center text-white py-2 px-4">
          <img src="/assets/img/radix-incentives/logo.png" className="h-4" />
          <p className="text-sm sm:block hidden font-medium absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">Earn $XRD by participating in the Radix network</p>

          <a
            href="https://incentives.radixdlt.com"
            target="_blank"
            className="
									focus:ring-2 focus:ring-astro focus:ring-offset-2 cursor-pointer
									bg-white text-black border hover:bg-black hover:text-white dark:bg-white/[0.04] dark:text-[#e8e8ee]
									tracking-astro font-optical-24-550 flex items-center justify-center rounded-full px-3 py-1 text-sm mt
								"
          >Join now
            <ChevronRightIcon className="size-3" /></a>

        </div> */}

        <RadixProvider>
          <Header />
          <main className="z-10 mt-5 lg:mt-12">
            <Outlet />
            <TransactionNotification />
            <ScrollRestoration />
          </main>
          <Footer />
        </RadixProvider>

        <Scripts />

        {/* <VemetricScript
          token="XzGrWN0frny4yQfr"
          host="https://hub.defiplaza.net"
          scriptUrl="https://hub.defiplaza.net/main.js"
          maskPaths={["/widget/staking/*", "/liquidity/add/*", "/liquidity/remove/*"]}
        /> */}
      </body>
    </html>
  );
}
